import { marked } from 'marked'

# Renders one CMS-managed home page feature (from the `homeFeature` content type).
# Right panel shows an embedded Google map when `mapEmbedUrl` is set, otherwise the image.
tag home-feature

	# tel: href built from the digits of the phone number
	get telHref
		"tel:" + String(data.phone or '').replace(/[^0-9]/g, '')

	# button style variant, restricted to the known .btn variants
	get btnStyle
		data.buttonStyle or 'primary'

	# only embed maps from the trusted Google Maps embed endpoint
	get safeMap
		let u = String(data.mapEmbedUrl or '')
		u.indexOf('https://www.google.com/maps/embed') == 0 ? u : ''

	<self.home-feature>
		<div.container .flipped=flipped>
			<div.left-panel>
				<div.title> data.title
				<div.body innerHTML=marked.parse(data.body or '')>
				if data.phone or (data.buttonLabel and data.buttonUrl)
					<div.actions>
						if data.phone
							<a.btn.btn-primary href=telHref target="_blank"> data.phone
						if data.buttonLabel and data.buttonUrl
							<a.btn href=data.buttonUrl target="_blank" rel="noopener"
								.btn-primary=(btnStyle == 'primary')
								.btn-success=(btnStyle == 'success')
								.btn-warning=(btnStyle == 'warning')
								.btn-danger=(btnStyle == 'danger')> data.buttonLabel
			<div.right-panel style="background-image:url({data.imageUrl})">
				if safeMap
					<iframe.map
						src=safeMap
						width="100%"
						height="100%"
						allowfullscreen
						loading="lazy">

css
	.home-feature
		my:4em
		d:flex
		jc:center
	.container
		d:flex
		w:75%
		shadow: 0px 0px 20px rgba(0,0,0,.25)
		rd:lg
		rd@lt-lg:0
		fld@lt-lg:column-reverse

		&.flipped
			fld:row-reverse
			fld@lt-lg:column-reverse
			.right-panel
				rdr:unset
				rdl:lg
				rdl@lt-lg:0
	.left-panel
		d:flex
		fld:column
		flb:50%
		p:1em 2em 2em 2em
		fs@xs:1em
		fs@sm:1.1em
		fs@md:1.25em
		fs@lg:1.50em
		fs@xl:1.75em
	.right-panel
		rdr:lg
		rdr@lt-lg:0
		d:flex
		flb:50%
		bgr:no-repeat
		bgp:50%
		bgs:cover
		min-height:400px
		.map
			flg:1
			w:100%
			border:0
	.title
		fs:2em
		font-style:italic
		ff:serif
		mb:.5em
	.body
		c:rgba(0,0,0,.75)
	.actions
		d:flex
		gap:1em
		flw:wrap
		mt:1.5em
